import React, { ReactNode } from 'react'

interface ILeaveProps {
  children: ReactNode
}

export const Leave = (props: ILeaveProps) => {
  return <div className="ly-leave">{props.children}</div>
}
